import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from 'src/store/api/useAuthStore';

const ClubProtectedRoute: React.FC = () => {
  const { token } = useAuthStore((state) => ({
    token: state.token,
  }));

  if (!token) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default ClubProtectedRoute;
